import React, { useState } from "react";
import { Box, Typography, IconButton, useMediaQuery } from "@mui/material";
import { styled } from "@mui/system";
import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";
import { QuotIcon } from "../constant";
// Testimonials Data

const TestimonialCard = styled(Box)`
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  padding: 20px;
  color: #ffffff;
  max-width: 332px;
  min-height: 380px;
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: left;
  text-align: left;
  transition: transform 0.3s ease, opacity 0.3s ease;
  background-image: url("/SliderCardBg.svg"); /* Reference from public folder */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const SliderContainer = styled(Box)({
  position: "relative",
  width: "100%",
  overflow: "hidden",
});

const SlidesWrapper = styled(Box)({
  display: "flex",
  transition: "transform 0.5s ease-in-out",
});

const Slide = styled(Box)({
  flex: "0 0 auto",
  padding: "0 4px",
});

const CustomSlider = ({ testimonials }) => {
  const [currentIndex, setCurrentIndex] = useState(2); // Centering the middle slide
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(max-width:960px)");

  const visibleSlides = isMobile ? 1 : isTablet ? 2 : 3;

  // Next Slide Function
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  // Previous Slide Function
  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  return (
    <Box
      sx={{
        padding: 4,
        textAlign: "center",
        background: "#000",
        color: "#fff",
        position: "relative",
        "&::after": {
          content: '""',
          position: "absolute",
          width: "100%",
          height: "50%",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          background:
            "radial-gradient(circle, rgba(99, 102, 241, 0.65) 0%, rgba(99, 102, 241, 0) 70%)",
          filter: "blur(100px)",
          //backdropFilter: "blur(500px)",
          zIndex: 0,
        },
      }}
    >
      <Box sx={{ zIndex: 2, position: "relative" }}>
        <Typography
          variant="h4"
          sx={{ marginBottom: {xs:0,md:8}, fontWeight: "bold", color: "#6B8AFE" }}
        >
          Transforming Operations. Earning Trust.
        </Typography>

        {/* Slider */}
        <SliderContainer>
          <SlidesWrapper
            sx={{
              transform: `translateX(-${(currentIndex - 2) * 332}px)`,
              mt:{xs:0 ,md:4},
            }}
          >
            {testimonials?.map((testimonial, index) => (
              <Slide key={index}>
                <TestimonialCard
                  sx={{
                    transform:
                      index === currentIndex &&
                      (visibleSlides === 3 || visibleSlides === 2)
                        ? "scale(1.2)"
                        : "scale(0.8)",
                    opacity:
                      index === currentIndex || visibleSlides !== 3 ? 1 : 0.2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between", // Ensures spacing between top and bottom content
                    alignItems: "flex-start",
                    textAlign: "left",
                    height: "100%", // Ensures full height usage
                    padding: index === 0? "40px": "20px",
                  }}
                >
                  {/* Top Content */}
                  <Box>
                    <img src={QuotIcon} sx={{ marginBottom: 2 }} />
                    <Typography variant="body1">
                      {testimonial?.quote}
                    </Typography>
                  </Box>

                  {/* Bottom Content */}
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{ color: "#8C8CC2", fontWeight: "bold" }}
                    >
                      {testimonial?.author}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#ccc" }}>
                      {testimonial?.note}
                    </Typography>
                  </Box>
                </TestimonialCard>
              </Slide>
            ))}
          </SlidesWrapper>

          {/* Navigation Buttons */}
          <Box sx={{ display: "flex", justifyContent: "center", mt: {xs:0 ,md:12} }}>
            <IconButton
              onClick={handlePrev}
              sx={{
                color: "white",
                background: "rgba(255,255,255,0.2)",
                mx: 1,
                borderRadius: "50%",
              }}
            >
              <ArrowBackIosNew />
            </IconButton>
            <IconButton
              onClick={handleNext}
              sx={{
                color: "white",
                background: "rgba(255,255,255,0.2)",
                mx: 1,
                borderRadius: "50%",
              }}
            >
              <ArrowForwardIos />
            </IconButton>
          </Box>
        </SliderContainer>
      </Box>
    </Box>
  );
};

export default CustomSlider;
